import React, { Fragment, useEffect } from 'react';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { SALESFORCE } from '../../../../constants/APIs';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { changeSalesforceId } from '../../../../redux/actions';
import Axios from 'axios';
function Index({ salesforceId }) {
    useEffect(() => {
        var code = window.location.href.substring(window.location.href.lastIndexOf("=") + 1,
            window.location.href.length);
        var integration_id = salesforceId;
        console.log(code, integration_id);
        let inputData = {
            groupId: getGroupID(),
            code: code,
            iid: integration_id
        }
        if (integration_id !== '' && inputData.code.includes('app/pages') !== true) {
            fetch(SALESFORCE, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    groupId: getGroupID(),
                    code: code,
                    iid: integration_id
                })
            }).then(res => {

                changeSalesforceId('');
                localStorage.setItem("ShowConfirm", true);
                window.location.href = `/app/pages/integration/applications`;
            });
        } else {
            window.location.href = `/app/pages/integration/applications`;
        }
    });

    return (
        <Fragment></Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, salesforceId } = settings;
    return {
        propertyId, salesforceId
    };
};

export default injectIntl(connect(mapStateToProps, { changeSalesforceId })(Index));